import { render, staticRenderFns } from "./SemesterValue.vue?vue&type=template&id=c54df9c8"
import script from "./SemesterValue.vue?vue&type=script&lang=js"
export * from "./SemesterValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports